import { ConverterRule } from '../types'

/**
 * Creates an array of ConverterRule for the PredicateConverter with explicit specification of Fallback ConverterRule
 */
export const createConverterRulesArray = <InputEntity, OutputEntity>(
  rules: Array<ConverterRule<InputEntity, OutputEntity>>,
  fallbackRule: ConverterRule<InputEntity, OutputEntity>,
): Array<ConverterRule<InputEntity, OutputEntity>> => [...rules, fallbackRule]
